import { render, staticRenderFns } from "./error_notification.vue?vue&type=template&id=144a2592&scoped=true&"
import script from "./error_notification.vue?vue&type=script&lang=js&"
export * from "./error_notification.vue?vue&type=script&lang=js&"
import style0 from "./error_notification.vue?vue&type=style&index=0&id=144a2592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a2592",
  null
  
)

export default component.exports